import AlertConfirmDialog from "@/components/custom-ui/alert.confirm.dialog";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useUserStore } from "@/store/user";
import { AlertCircle } from "lucide-react";
import { useState, useEffect } from "react";

const Inactive = () => {
  const user = useUserStore((store) => store.user);
  const logout = useUserStore((store) => store.logout);
  const sendLink = useUserStore((store) => store.sendNewActivationLink);

  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(60);

  const handleSendLink = () => {
    setIsLoading(true);
    setTimer(60);
    sendLink();

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(interval);
      setIsLoading(false);
    }, 60000);
  };

  useEffect(() => {
    if (timer <= 0) {
      setIsLoading(false);
    }
  }, [timer]);

  return (
    <div className="min-h-screen flex justify-center items-center">
      <Alert variant="default" className="w-1/2">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle className="mb-4">Аккаунт не активирован</AlertTitle>
        <AlertDescription className="text-justify">
          {`${user.name}, для завершения регистрации необходимо подтвердить ваш почтовый адрес ${user.email}, на него было выслано письмо с инструкциями и ссылкой необходимой для активации аккаунта. Пожалуйста, перейдите по ссылке и обновите страницу.`}
        </AlertDescription>
        <div className="mt-4 flex justify-between text-primary">
          <Button variant="outline" onClick={handleSendLink} disabled={isLoading}>
            {isLoading ? `Запросить новую ссылку (${timer})` : "Запросить новую ссылку"}
          </Button>
          <AlertConfirmDialog func={logout} body={`Покинуть сайт?`}>
            <Button variant="destructive">Выйти</Button>
          </AlertConfirmDialog>
        </div>
      </Alert>
    </div>
  );
};

export default Inactive;
